import { Check } from "lucide-react";

export function StatusTimeline({ stages, current, closed }) {
  return (
    <div className="relative">
      {stages.map((label, i) => {
        const stageNum = i + 1;
        const done = !closed && stageNum <= current;
        const isCurrent = !closed && stageNum === current;
        return (
          <div key={i} className="flex gap-4 pb-6 last:pb-0 relative">
            {i < stages.length - 1 && (
              <span className={`absolute left-[15px] top-8 bottom-0 w-0.5 ${done ? "bg-[#D4AF37]" : "bg-slate-200"}`} />
            )}
            <span className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
              done ? "bg-[#D4AF37] text-[#0A1128]" : isCurrent ? "bg-[#0A1128] text-white ring-4 ring-[#D4AF37]/30" : "bg-slate-100 text-slate-400 border border-slate-200"
            }`}>
              {done ? <Check className="h-4 w-4" /> : stageNum}
            </span>
            <div className="pt-1">
              <p className={`text-sm font-medium ${done || isCurrent ? "text-slate-900" : "text-slate-400"}`}>{label}</p>
              {isCurrent && <p className="text-xs text-[#8a6d0f] font-medium mt-0.5">In corso</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
